import classNames from "classnames";

import { useConfirm } from "src/zustand/confirm";

import { TYPE_COLORS } from "./config";

export const CConfirm = () => {
  //#region Data
  const {
    show,
    title,
    content,
    type = "error",
    onConfirm,
    confirmText,
    onCancel,
    cancelText,
    close,
  } = useConfirm();

  console.log("🤣 type at line 21 🤣:", type);
  const { icon, iconColor, buttonColor } = TYPE_COLORS[type];
  //#endregion

  //#region Event
  //#endregion

  //#region Render
  return (
    <div
      className={classNames(
        "fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-slate-900/45 backdrop-blur-sm transition-opacity duration-200 [&_*]:!font-inter",
        show
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none",
      )}
      onClick={close}
    >
      <div
        className="relative mb-[20rem] bg-white text-slate-800 rounded-2xl border border-slate-100 w-full max-w-md shadow-2xl overflow-hidden transform transition-all scale-100 duration-300 ease-out"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6 flex gap-3 items-start">
          <div
            className={`flex-shrink-0 flex items-center justify-center w-14 h-14 rounded-full border-t border-b border-l border-r border-solid ${iconColor}`}
          >
            {icon}
          </div>

          <div className="flex-1 min-w-0">
            <h3 className="text-2xl font-semibold text-slate-600  mb-1.5">
              {title}
            </h3>
            <div className="text-slate-500 leading-relaxed break-words text-base whitespace-pre-line">
              {content}
            </div>
          </div>
        </div>

        <div className="flex justify-end items-center gap-3 px-6 pb-6">
          <button
            type="button"
            className="flex-1 text-base sm:flex-initial px-4 py-2 rounded-xl border border-slate-200  font-medium text-slate-600 hover:bg-slate-50 hover:text-slate-800 transition-all active:scale-[0.98] outline-none"
            onClick={() => {
              onCancel?.();
              close();
            }}
          >
            {cancelText}
          </button>

          {onConfirm && (
            <button
              type="button"
              className={`flex-1 text-base sm:flex-initial px-4 py-2 rounded-xl font-medium text-white shadow-sm transition-all active:scale-[0.98] outline-none ${buttonColor}`}
              onClick={() => {
                onConfirm();
                close();
              }}
            >
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
  //#endregion
};
